import script from "./FeedbackWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackWidget.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackWidget.vue?vue&type=style&index=0&id=c0aa7b4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0aa7b4a"]])

export default __exports__